<template>
  <form
    autocomplete="off"
    class="m-1 w-auto"
    @submit.prevent="fetchResults"
  >
    <vue-autosuggest
      ref="autosuggest"
      v-model="query"
      class="navigation-search"
      :class="{ expanded: showInput }"
      :suggestions="suggestions"
      :input-props="inputProps"
      :section-configs="sectionConfigs"
      :should-render-suggestions="() => showInput"
      :limit="10"
      autocomplete="off"
      @input="fetchResults"
    >
      <template slot="before-input">
        <feather-icon
          class="search-icon text-secondary font-weight-bold"
          size="16"
          icon="SearchIcon"
        />
      </template>
      <template slot-scope="{suggestion}">
        <div v-if="suggestion.name === 'pages'">
          <div class="d-flex align-items-center cursor-pointer">
            <feather-icon
              :icon="suggestion.item.icon"
              size="18"
              class="mr-75"
            />
            <span>{{ suggestion.item.title }}</span>
          </div>
        </div>
      </template>
    </vue-autosuggest>
  </form>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import getSearchIndex from '@/search/search-index'

export default {
  name: 'NavigationSearch',
  components: {
    VueAutosuggest,
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showInput: this.expanded,
      data: {},
      query: '',
      suggestions: [],
      selected: null,
      sectionConfigs: {
        pages: {
          limit: 6,
          onSelected: selected => {
            if (!selected?.item) return
            if (selected?.item?.route && selected?.item?.route?.name !== this.$route.name) {
              this.$router.push(selected?.item?.route).catch(() => { })
            }
            this.query = ''
            this.suggestions = []
          },
        },
      },
      limit: 10,
    }
  },
  computed: {
    isSuperAdminRoute() {
      return this.$store.getters['navigation/isSuperAdminRoute']
    },
    inputProps() {
      const { locale } = this.$i18n

      return {
        id: 'autosuggest__input',
        class: `navigation-search-input form-control ${this.showInput ? '' : 'd-none'}`,
        placeholder: `${this.$t('navigation.explore-options', locale)}`,
      }
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.data = getSearchIndex()
      this.fetchResults()
    },
    isSuperAdminRoute() {
      this.data = getSearchIndex()
      this.fetchResults()
    },
    expanded(expanded) {
      if (!expanded) this.showInput = false
      else setTimeout(() => { this.showInput = true }, 400)
    },
  },
  mounted() {
    this.data = getSearchIndex()
    this.showInput = this.expanded
  },
  methods: {
    fetchResults(text) {
      this.suggestions = []

      if (!text) {
        return
      }
      const mappedData = this.data.pages.data.map(item => {
        let { title } = item
        if (item.title instanceof Function) {
          title = this.$t(item.title())
        } else {
          title = item.title
        }
        return { ...item, title }
      })

      const filteredPages = mappedData.filter(item => item.title.toLowerCase().indexOf(text.toLowerCase()) > -1 || ((item.stepsNames ?? []).some(step => this.$t(step).toLowerCase().indexOf(text.toLowerCase()) > -1))).slice(0, this.limit)

      if (filteredPages.length) {
        this.suggestions.push({ name: 'pages', data: filteredPages })
      }
    },
  },
}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';

.navigation-search {
  border: 1px solid var(--custom-control-border-color);
  border-radius: 6px;

  div[role=combobox] {
    display: inline-flex;

    input {
      border: 0;
      max-width: 140px;
      box-shadow: none !important;
      line-height: 1.25 !important;
      padding: 13px 12.3px 14px;
      font-size: 13px !important;
    }
  }

  .search-icon {
    margin: 12px;
  }

  .navigation-search-input {
    &::placeholder {
      font-family: 'Montserrat', Helvetica, Arial, serif;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.25 !important;
    }
  }
}
</style>
